import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import Register1 from '../../components/Auth/Register1';
import SmashLoader from '../../components/Loader/SmashLoader';
import useAuth from '../../utils/hooks/useAuth';
import authPersonBackground from '../../assets/auth_person_background.svg';

export default function Register() {
  const navigate = useNavigate();
  const { registerUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const methods = useForm({ mode: 'onChange', criteriaMode: 'all' });

  const errors = {
    '001': 'Email is already in use',
    '002': 'Email is required',
    '003': 'Password is required',
    '004': 'Invalid date format',
    '005': 'Serializer error',
    999: 'Something went wrong',
  };

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await registerUser(data);
      toast.success('Registration successful. Redirecting to login...');
      setTimeout(() => navigate('/login'), 5000);
    } catch (error) {
      console.error('Register failed', error);
      toast.dark(errors[error.code] || errors['999']);
      setIsLoading(false);
    }
  };

  if (isLoading) return <SmashLoader />;

  return (
    <div className="flex min-h-[calc(100vh-4rem)] w-full flex-row items-start justify-center overflow-y-auto bg-blue-50 p-6 dark:bg-slate-900 lg:gap-16">
      <div className="flex h-full w-full flex-grow flex-col items-center justify-start lg:items-end">
        <div className="flex w-full max-w-96 flex-col gap-2 font-inter">
          <Register1 onSubmit={onSubmit} methods={methods} />
          <div className="flex flex-col gap-3 pb-6 lg:pb-0">
            <p className="text-center text-sm text-gray-600 dark:text-gray-400">
              Already have an account?{' '}
              <Link to="/login" className="font-semibold text-blue-500 hover:underline dark:text-blue-400">Login</Link>
            </p>
            <p className="text-center text-sm text-gray-600 dark:text-gray-400">
              By creating an account, you agree to our{' '}
              <Link to="#" className="underline dark:text-blue-400">Terms of Service</Link>{' '}
              and{' '}
              <Link to="#" className="underline dark:text-blue-400">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </div>
      <div className="hidden h-full w-full flex-grow flex-row items-center justify-start pt-7 lg:flex">
        <div className="flex h-[620px] max-w-96 flex-col items-center justify-center gap-20 rounded-xl bg-cover bg-top py-6" style={{ backgroundImage: 'url("./auth_background.png")' }}>
          <div className="flex w-full flex-col items-center justify-center gap-6 px-14 text-left font-poppins text-neutral-50">
            <p className="w-full text-3xl font-medium">Your Voice. Your Story. Your Future.</p>
            <p className="w-full font-inter text-sm">Your story is more than a number. Show who you really are through a personalized, AI-powered interview.</p>
          </div>
          <img src={authPersonBackground} alt="auth background" className="w-1/2 object-cover" />
        </div>
      </div>
    </div>
  );
}
